import { BrowserRouter } from "react-router-dom";
import React, { Suspense, lazy } from "react";
import { render } from "react-dom";
import GlobalLoader from "./components/GlobalLoader";

//Polyfills
import "core-js/features/object/from-entries";
import "core-js/features/object/entries";
import "core-js/features/object/values";
import "core-js/features/array/map";
import "core-js/features/array/flat-map";
import "core-js/features/array/for-each";
import "core-js/features/array/filter";

const App = lazy(() => import("./App"));

render(
  <Suspense fallback={<GlobalLoader />}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Suspense>,
  document.getElementById("content")
);

if (module.hot) {
  module.hot.accept();
}
